import { Button } from '@mui/material'
import styles from './DropDown.module.scss'
import { dropdownStyles } from './DropDown.styles'

interface DropDownProps {
  text: string
  fontSize: string
  icon: string
  toggledIcon: string
  iconFontSize: string
  isToggled: boolean
  onClick: () => void
}
function DropDown(props: DropDownProps) {
  const {
    text,
    fontSize,
    icon,
    toggledIcon,
    iconFontSize,
    isToggled,
    onClick
  } = props
  return (
    <Button sx={dropdownStyles} onClick={onClick} disableRipple>
      <p className={`${fontSize} ${styles.dropDownLabel}`}>{text}</p>
      {icon && toggledIcon && iconFontSize && (
        <i
          className={`${iconFontSize} ${isToggled ? toggledIcon : icon} ${
            styles.textComponentIcon
          }`}
        />
      )}
    </Button>
  )
}

export default DropDown
